export default "__VITE_ASSET__Cs1A4I$5__"